/* global axios */
import ApiClient from './ApiClient';

class Translations extends ApiClient {
  constructor() {
    super('translations', { accountScoped: true });
  }
  
  translate(locale, content) {
    const requestURL = `${this.url}/translate`;

    return axios.post(requestURL, {
      locale: locale,
      content: content
    });
  }
}

export default new Translations();
